import { BaseComponent } from "../BaseComponent";
import { Box } from '../../other/box.model';
import { Position2D } from '../../other/position2D.model';
import { Position3D } from '../../other/position3D.model';
import { ComponentNames } from 'src/app/helper/componentNames';


export class BaseDimensionComponent extends BaseComponent {
    constructor() {
        super();
        this.componentType = ComponentNames.baseDimensionsComponent;
    }
    posX: number;
    posY: number;
    posZ: number;
    rotation: number;
    box: Box;

    public SetPosition(x: number, y: number, z: number, r: number = 0) {
        this.posX = x;
        this.posY = y;
        this.posZ = z;
        this.rotation = r;
    }

    public Test() {
        this.SetPosition(1, 2, 3);
        this.SetPosition(1, 2, 3, 2);
    }

    getCenter2D(): Position2D {
        switch (this.rotation) {
            case 0:
                return new Position2D(this.posX + (this.box.width / 2), this.posY + (this.box.length / 2));
            case 1:
                return new Position2D(this.posX - (this.box.width / 2), this.posY + (this.box.length / 2));
            case 2:
                return new Position2D(this.posX - (this.box.width / 2), this.posY - (this.box.length / 2));
            case 3:
                return new Position2D(this.posX + (this.box.width / 2), this.posY - (this.box.length / 2));
        }
    }
    getCenter3D(): Position3D {
        var temp = new Position2D(this.posX + (this.box.width / 2), this.posY + (this.box.length / 2));
        //missing 3d part
        throw new Error("Notimpl");

    }
    xSize(): number {
        if (this.rotation == 0 || this.rotation == 2)
            return this.box.width;

        return this.box.length;
    }
    ySize(): number {
        if (this.rotation == 0 || this.rotation == 2)
            return this.box.length;

        return this.box.width;
    }
    xLeft(): number {
        return this.posX;
    }
    xRight(): number {
        var add = 0;
        if (this.rotation == 0 || this.rotation == 2)
            add = this.box.width;
        else
            add = this.box.length;

        return this.posX + add;
    }
    yUpper(): number {
        return this.posY;
    }
    yLower(): number {
        var add = 0;
        if (this.rotation == 0 || this.rotation == 2)
            add = this.box.length;
        else
            add = this.box.width;

        return this.posY + add;
    }
}